import React from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";

function Footer() {
    return (
        <footer class="footer footer-center p-10 rounded font-quicksand pt-10" data-theme="weireframe">
            <div>
                <div className="grid grid-flow-col gap-2">
                    <div className="grid grid-flow-col gap-2">
                        <a href="https://www.facebook.com/vcaremyanmar">Facebook |</a>
                    </div>
                    <a href="https://willowlabelmm.com/terms" className="link link-hover" >Terms & Conditions |</a>
                    <Link to={paths.contact} className="link link-hover" >Contact</Link>
                </div>
                <div className="pt-8">
                    <p>Copyright © {(new Date().getFullYear())} - All rights reserved by VCARE Pharmacy.</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;